import { IAnimationFrame } from "./Types";

export class AnimationFramePool {
    private static framesPool: Array<IAnimationFrame> = [];

    static registerFrame(frame: IAnimationFrame): boolean {
        var pool = AnimationFramePool.framesPool;
        for (var i = 0; i < pool.length; i++) {
            if (pool[i].frame_uid === frame.frame_uid) {
                //frame.log(`already registered on Stage controller frame pool!`, true);
                return false;
            }
        }

        pool.push(frame);
        return true;
    }

    static unregisterFrame(frame: IAnimationFrame): boolean {
        var pool = AnimationFramePool.framesPool;
        var idx = -1;
        for (var i = 0; i < pool.length; i++) {
            if (pool[i].frame_uid === frame.frame_uid) {
                idx = i;
                break;
            }
        }

        var result = idx > -1;
        if (result) {
            // fail safe check
            if (pool[idx].frame_uid === frame.frame_uid) {
                pool.splice(idx, 1);
            } else {
                result = false;
            }
        }

        return result;
    }

    static draw(): void {
        // loop and paint all animation frames from pool
        var pool = AnimationFramePool.framesPool;
        for (var i = 0; i < pool.length; i++) {
            var frame = pool[i];
            frame.frame_draw();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/AnimationFrame/Pool.ts
 **/